export default __webpack_public_path__ + "static/media/kyc.60807ffa.png";